import * as types from './constants';

// Get Invitation
export const getInvitationsRequest = data => (
  { type: types.GET_INVITATIONS_REQUEST, payload: data }
);

export const getInvitationsDone = data => (
  { type: types.GET_INVITATIONS_DONE, payload: data }
);

export const getInvitationsFailed = errors => (
  { type: types.GET_INVITATIONS_FAILED, payload: errors }
);

// Resend Invitation
export const resendInvitationRequest = data => (
  { type: types.RESEND_INVITATION_REQUEST, payload: data }
);

export const resendInvitationDone = data => (
  { type: types.RESEND_INVITATION_DONE, payload: data }
);

export const resendInvitationFailed = errors => (
  { type: types.RESEND_INVITATION_FAILED, payload: errors }
);

export const resendInvitationReset = () => (
  { type: types.RESEND_INVITATION_RESET }
);

// Delete Invitation
export const deleteInvitationRequest = data => (
  { type: types.DELETE_INVITATION_REQUEST, payload: data }
);

export const deleteInvitationDone = data => (
  { type: types.DELETE_INVITATION_DONE, payload: data }
);

export const deleteInvitationFailed = errors => (
  { type: types.DELETE_INVITATION_FAILED, payload: errors }
);

// Operations
export const invitationsSetPage = data => (
  { type: types.INVITATIONS_SET_PAGE, payload: data }
);